import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { CardController } from 'src/app/shared/card.controller';
import { TextView } from 'src/core/ui/text.view';
import { RoleUserEditorController } from 'src/app/general/roles/parts/role-user-editor.controller';

interface Props extends ComponentViewProps<UserItem> {
	mode: ControlMode;
	isAdministrator: boolean;
	onAvatarChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;
	createNewUserRole: (roleId: number) => Promise<UserRoleSummary>;
	onCancel: () => Promise<any>;
	roles: DataSet<UserRoleSummary>;
}

@observer
export class UserInfoView extends React.Component<Props, {}>{
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render(): JSX.Element {
		const { model, isAdministrator } = this.props;
		const noAvatar = 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAVCAYAAAAnzezqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAGYktHRAD/AP8A/6C9p5MAAAHZSURBVEhLxZW7jsJADEU9QTwaGhqE+ADEo0dIUPLVNPwDCAQtIOh5v5czi0PE7mYmxYorWTOx79g3licxvV7vLh9E8Fw/Bm8B9/vdmgu+PIWXgNvtZtfL5RKbnBgcoGdccArQN+p2u9JsNmW/3/8qAh8xOHD1nAuBEv+y8/ksrVbLkguFgrTb7VBE1PARgwM4w9l33rsFtCrOgiCQfr8v2+3WJqZAp9OR3W4n1+vVGnt8WhwuZzj7W86omfF47OwTSo/Ho9RqNclkMtbH82QysftKpSLZbNbuT6eTjEYj+2yMsb44mMFg4D2ytBQRWmy9Xts1n8/bFVEUT6fT9tkHZjgcegugE4ioVquSy+We3m8cDgd5dNMW93lzRaIPEYkp8BD99LyAL2lxkEiAdqDRaDw9L+DTqU8C5zWMms6Atp8Z0DnAR0xF+JqXAK4Liev1ejiAm81GptOpNfaAGJwkIsx8Pnf2DAHlctnea8DArVarcNopWCqVQnHwF4tFyI+DswN824vF4o/iqVQq5LBfLpc2BuByRv8dceaUSDIKgmjx6LSzx0dMRbD36YCZzWZeX0JAa0n611WDpxzgcyXdEh/QRHHFAbEkxYGXAEBCn6S+PIW3gP+ByBfxJS5nmEXtPwAAAABJRU5ErkJggg==';
		const avatar = model.avatar != null && model.avatar.length > 0 ? btoa(String.fromCharCode.apply(null, model.avatar)) : noAvatar;

		const firstName = model.dynamicProperties['firstName'] as string;
		const lastName = model.dynamicProperties['lastName'] as string;
		const telephone = model.dynamicProperties['telephone'] as string;
		return (
			<CardController
				className="card-borderless"
				mode={this.props.mode}
				icon="profile"
				title="User information"
			>
				<Row gutter={16}>
					<Col xs={16}>
						<TextView
							required
							label="User Name"
							value={this.props.model.userName}
							onChanged={newVal => model.userName = newVal}
							onGetErrorMessage={() => this.props.model.validate(true, 'userName')}
							mode={isAdministrator ? this.props.mode : 'display'}
						/>
						<RoleUserEditorController
							setBusy={this.props.setBusy}
							mode={isAdministrator ? this.props.mode : 'display'}
							model={this.props.model}
							title="User roles"
							onCancel={this.props.onCancel}
							createNewUserRole={this.props.createNewUserRole}
							roles={this.props.roles}
						/>
						<TextView
							required
							label="Display Name"
							value={this.props.model.displayName}
							onGetErrorMessage={() => this.props.model.validate(true, 'displayName')}
							onChanged={val => this.props.model.displayName = val}
							mode={this.props.mode}
						/>
						<Row gutter={16}>
							<Col xs={12}>
								<TextView
									label="First Name"
									value={firstName}
									onChanged={val => this.props.model.dynamicProperties['firstName'] = val}
									mode={this.props.mode}
								/>
							</Col>
							<Col xs={12}>
								<TextView
									label="Last Name"
									onChanged={val => this.props.model.dynamicProperties['lastName'] = val}
									value={lastName}
									mode={this.props.mode}
								/>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={12}>
								<TextView
									label="Telephone"
									mode={this.props.mode}
									onGetErrorMessage={() => this.props.model.validate(true, 'dynamicProperties')}
									onChanged={val => this.props.model.dynamicProperties['telephone'] = val}
									value={telephone}
								/>
							</Col>
							<Col xs={12}>
								<TextView
									required
									label="Email"
									mode={this.props.mode}
									onGetErrorMessage={() => this.props.model.validate(true, 'notificationEmail')}
									onChanged={val => this.props.model.notificationEmail = val}
									value={this.props.model.notificationEmail}
								/>
							</Col>
						</Row>
					</Col>
					<Col xs={8}>
						<label>Signature</label>
						<label htmlFor='logo' className="label-image text-center">
							<img src={'data:image/png;base64,' + avatar} style={{ width: "100%" }} alt="Select an image" />
							<input disabled={this.props.mode == 'display'} id="logo" type="file" style={{ display: 'none' }} accept="image/*" onChange={this.props.onAvatarChange} />
						</label>
					</Col>
				</Row>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/users/form/parts/userinfo-form.view.tsx